import { roles } from '@nxsys/store/constants';
import DraftPayrollReport from '../../../modules/reports/payroll/listing/DraftPayrollReport';
import PayrollSummaryReport from '../../../modules/reports/payroll/listing/PayrollSummaryReport';
import { PAYMENT_MODEL_ENUM } from '@nxsys/constants/AppConstants';
import ViewPayrollDetail from '../../../modules/reports/payroll/detail';
import HolidayPayBalanceDetailReport from '../../../modules/reports/payroll/listing/HolidayPayBalanceDetailReport';
import HolidayPayBalanceSummaryReport from '../../../modules/reports/payroll/listing/HolidayPayBalanceSummaryReport';
import NetPayReport from '../../../modules/reports/payroll/listing/NetPayReport';
import FiftyTwoWeekReport from '../../../modules/reports/payroll/listing/FiftyTwoWeekReport';
import P30Report from '../../../modules/reports/payroll/listing/P30Report';
import P32Report from '../../../modules/reports/payroll/listing/P32Report';
import SafeRecPayslipSubmissionDetails from '../../../modules/reports/payroll/safeRecSubmission';

export const payrollReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/draft-payroll-summary',
    element: <DraftPayrollReport paymentModels={[PAYMENT_MODEL_ENUM.CIS]} />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/draft-payroll-payee-umbrella-summary',
    element: (
      <DraftPayrollReport
        paymentModels={[PAYMENT_MODEL_ENUM.PAYEE, PAYMENT_MODEL_ENUM.UMBRELLA]}
      />
    ),
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/cis-payment-summary',
    element: <PayrollSummaryReport paymentModels={[PAYMENT_MODEL_ENUM.CIS]} />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/payment-summary',
    element: (
      <PayrollSummaryReport
        paymentModels={[PAYMENT_MODEL_ENUM.PAYEE, PAYMENT_MODEL_ENUM.UMBRELLA]}
      />
    ),
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/holiday-pay-balance-detail',
    element: <HolidayPayBalanceDetailReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/holiday-pay-balance-summary',
    element: <HolidayPayBalanceSummaryReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/net-pay-report',
    element: <NetPayReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/52-week-average-summary-report',
    element: <FiftyTwoWeekReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/p30',
    element: <P30Report />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/p32',
    element: <P32Report />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/safe-rec-submission/:payrollId',
    element: <SafeRecPayslipSubmissionDetails />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/payroll/:payrollId',
    element: <ViewPayrollDetail />,
  },
];
